import { render, staticRenderFns } from "./EditStudent.vue?vue&type=template&id=69fbc8a3"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports